import React, { useState, useContext, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MenuCurso from '../components/MenuCurso';
import Leccion from '../components/Leccion';
import LoginCard from '../components/LoginCard';
import { post } from '../api/Api';
import Loader from '../components/Loader';
import { AuthContext } from '../contexts/AuthContext';
import Exit from '../components/Exit';
import { useParams, useNavigate } from 'react-router-dom';
import * as constants from '../constants/constants';
import { ConvertirSaltosDeLinea } from '../utils/TextUtils';
import FirmarDocumento from '../utils/FirmarDocumento';

function Curso() {
    const navigate = useNavigate();
    const { userData } = useContext(AuthContext);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [curso, setCurso] = useState([]);
    const [leccionSeleccionada, setLeccionSeleccionada] = useState(null);
    const [progreso, setProgreso] = useState([]);
    const [aprobado, setAprobado] = useState(false);
    const [fechaAprobado, setFechaAprobado] = useState('');

    const handleExit = Exit();

    const getCurso = async () => {
        setIsLoading(true);

        try {
            const formDataEnviar = new FormData();
            formDataEnviar.append('documento', userData?.documento);
            formDataEnviar.append('token', userData?.token);

            const response = await post('obtener_cursos', formDataEnviar);

            if (response.data.success) {
                const curso = response.data.data[0];
                setCurso(curso);
                setProgreso(curso.progreso || []);
                setFechaAprobado(curso.aprobado?.fecha);
                setAprobado(curso.aprobado?.aprobado);

                if (curso.lecciones && curso.lecciones.length > 0) {
                    setLeccionSeleccionada(curso.lecciones[0]);
                }
            } else {
                setError(response.data.message);
            }

        } catch (error) {
            setError(error?.response?.data?.message || error.message);
            if (error?.response?.data?.code === 401) {
                handleExit();
            }
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCurso();
    }, []);

    const handleDescargar = (fechaAprobado) => {
        FirmarDocumento(userData, fechaAprobado);
    };

    const handleIniciarExamen = () => {
        navigate(`${constants.EXAMEN.replace(':id', curso.certificacion_id)}`);
    };

    const onCompleteLeccion = async (leccionId) => {
        if (!progreso.includes(leccionId)) {
            setProgreso((prev) => [...prev, leccionId]);
            try {
                const formData = new FormData();
                formData.append('documento', userData?.documento);
                formData.append('token', userData?.token);
                formData.append('leccion_id', leccionId);
                formData.append('curso_id', curso?.id);

                await post('guardar_progreso_curso', formData);
            } catch (error) {
                console.error("Error guardando el progreso del curso:", error);
            }
        }
    };

    const todasLeccionesCompletadas = curso.lecciones && progreso.length === curso.lecciones.length;

    return (
        <div className='auteco_pagina-curso'>
            <Header />
            <div className='contenedor'>
                <div className='menu-curso'>
                    <LoginCard />
                    {isLoading ? (
                        <Loader />
                    ) : (
                        !error && (
                            <>
                                {aprobado && (
                                    <div className="boton-descarga">
                                        <button
                                            className="auteco_button download"
                                            onClick={() => handleDescargar(fechaAprobado)}
                                            disabled={!aprobado}
                                        >
                                            <i className="material-symbols-outlined">download</i>
                                            <div className='textos'>
                                                <div className='titulo'>Conductor certificado</div>
                                                <div className='subtitulo'>Descarga tu diploma aquí</div>
                                            </div>
                                        </button>
                                    </div>
                                )}

                                <MenuCurso
                                    lecciones={curso.lecciones}
                                    onSelectLeccion={setLeccionSeleccionada}
                                    leccionSeleccionada={leccionSeleccionada}
                                    progreso={progreso}
                                />
                            </>
                        ))}
                    {error && <div className="auteco_error-message">{error}</div>}
                </div>

                <div className='curso'>
                    {isLoading ? (
                        <Loader />
                    ) : (
                        !error &&
                        <>
                            <div className="cabecera" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${curso?.imagen?.url})` }}>
                                <div className='titulos'>
                                    <div className='titulo'>{curso?.titulo}</div>
                                    <div className='subtitulo'>{ConvertirSaltosDeLinea(curso?.descripcion)}</div>
                                </div>
                            </div>

                            <Leccion
                                leccion={leccionSeleccionada}
                                lecciones={curso.lecciones}
                                onChangeLeccion={setLeccionSeleccionada}
                                onCompleteLeccion={onCompleteLeccion}
                                progreso={progreso}
                            />
                        </>
                    )}
                </div>
            </div>

            <Footer />

            {curso.certificacion_id && todasLeccionesCompletadas && !aprobado && (
                <div className='iniciar-examen'>
                    <div className='textos'>
                        <div className='titulo'>Tomar el examen</div>
                        <div className='contenedor-linea'>
                            <div className='auteco_separador-horizontal'></div>
                        </div>
                        <div className='subtitulo'>
                            <strong>¿Listo para el siguiente paso?</strong><br /><br />
                            Haz clic en <strong>"Iniciar examen"</strong> aprueba y optén tu certificado.<br /><br />
                            ¡La prueba de tu conocimiento adquirido comienza aquí!
                        </div>
                    </div>
                    <div className='boton'>
                        <div
                            className="auteco_button primary"
                            onClick={handleIniciarExamen}
                        >
                            Iniciar examen
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Curso;
